import {
	REQUEST_GET_APPLICATION_STATUSES, RECEIVE_GET_APPLICATION_STATUSES,
	RECEIVE_BAD_REQUEST_GET_APPLICATION_STATUSES
} from "./index";


export function requestGetApplicationStatuses(){
	return {
		type: REQUEST_GET_APPLICATION_STATUSES
	}
}

export function receiveApplicationStatuses(payload){
	return {
		type: RECEIVE_GET_APPLICATION_STATUSES,
		payload
	}
}

export function receiveBadRequestApplicationStatuses(payload){
	return {
		type: RECEIVE_BAD_REQUEST_GET_APPLICATION_STATUSES,
		payload
	}
}
